import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';

/**
 * Guard to restrict access to routes based on granular permissions.
 * Usage in routes:
 * { 
 *    path: 'path', 
 *    component: MyComponent, 
 *    canActivate: [permissionGuard], 
 *    data: { permission: 'module:action' } 
 * }
 */
export const permissionGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authService = inject(AuthService);
    const toast = inject(ToastService);

    const requiredPermission = route.data['permission'] as string;

    // Si no se definió un permiso, permitimos el acceso (asumiendo que authGuard ya validó la sesión)
    if (!requiredPermission) {
        return true;
    }

    if (authService.hasPermission(requiredPermission)) {
        return true;
    }

    // Si no tiene permiso, notificamos y redirigimos al dashboard
    toast.show('No tienes permiso para acceder a esta sección', 'Acceso Denegado', 'error');
    router.navigate(['/app/dashboard']);
    
    return false;
};
